module.exports = __webpack_public_path__ + "img/345.6de268ef.png";